import {constants} from 'src/utils/const'
import {useMemo} from 'react'
import {useTable} from 'react-table'

import {PartyLedgerColumns} from './columns/_columns'
import {checkDisplayValue, formatDate} from 'src/utils'
import {useQueryResponseDataLedger, useQueryResponseLoading} from '../core/QueryResponseProvider'

const CopyPartyLedgersTable = () => {
  const PartyLedgers = useQueryResponseDataLedger()

  const isLoading = useQueryResponseLoading()

  const data = useMemo(() => PartyLedgers, [PartyLedgers])
  const columns = useMemo(() => PartyLedgerColumns, [])
  const {getTableProps, getTableBodyProps, headers, rows, prepareRow} = useTable({
    columns,
    data,
  })

  return (
    <table
      id='copy_kt_table_PartyLedger'
      className='table align-middle table-row-dashed fs-6 gy-5 table-striped table-hover dataTable no-footer'
      {...getTableProps()}
      style={{display: 'none'}}
    >
      <thead>
        <tr className='text-center text-muted fw-bolder fs-7 gs-0 border-bottom border-gray-100'>
          <td>ID</td>
          <td>DATE</td>
          <td>RECEIVER</td>
          <td>REMARKS</td>
          <td>CREDIT</td>
          <td>DEBIT</td>
          <td>BALANCE</td>
        </tr>
      </thead>
      <tbody className='text-gray-600' {...getTableBodyProps()}>
        {data.length > 0 ? (
          data.map((row: any, i: any) => {
            return (
              <tr key={i}>
                <td>{row?.message_type == 2 ? '-' : row?.message_id}</td>
                <td>{formatDate(row?.created_at, constants.DATE_FORMAT.DD_MM_YYYY_HH_MM_A)}</td>
                <td>{row?.message_type == 2 ? '-' : checkDisplayValue(row?.receiver)}</td>
                <td>{checkDisplayValue(row?.remarks)}</td>
                <td>{row?.credit.toLocaleString()}</td>
                <td>{row?.debit.toLocaleString()}</td>
                <td>{row?.balance.toLocaleString()}</td>
              </tr>
            )
          })
        ) : (
          <tr>
            <td colSpan={7}>
              <div className='d-flex text-center w-100 align-content-center justify-content-center'>
                No matching records found.
              </div>
            </td>
          </tr>
        )}
      </tbody>
    </table>
  )
}

export {CopyPartyLedgersTable}
